import { render } from "./FinancialPlanning.vue?vue&type=template&id=cac96536"
import script from "./FinancialPlanning.vue?vue&type=script&lang=js"
export * from "./FinancialPlanning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__